module.exports = __webpack_public_path__ + "static/cpdp-a2ee3f7005ccc5d18e347c20925dc17f.png";